@let showCurrency = shopCurrency$ | async;

<div class="card-wrapper" [tooltip]="getTooltipKey(showCurrency, hasWayForPay()) | translate">
    <div
        class="card"
        [class.disabled]="getIsDisabled(showCurrency, hasWayForPay())"
        (click)="setProductCardEvenEmitter.emit(element.id)"
    >
        <div class="image-wrapper">
            @if (element?.images?.length) {
                <img [src]="element.images[0] | fmFileUrl" alt="0" />
            } @else {
                <img [src]="'./assets/img/websites/lpc-empty-product.png'" alt="product_blank" />
            }
        </div>
        <div class="content">
            <div class="top-content strip-text">
                <h2 [title]="element.name.length > 20 ? element.name : ''">{{ element.name }}</h2>
                <span class="card-article strip-text">
                    {{ "widget_product_vendor_code" | translate }}: {{ this.element.vendorCode }}
                </span>
            </div>

            @if (isSubscriptionType) {
                <div
                    class="subscribe-block"
                    [tooltip]="
                        'widget_product_subscription_period_tooltip'
                            | translate: { period: subscribePeriodLabel | translate }
                    "
                >
                    <span class="sp-icon icon-repeat">&nbsp;</span> {{ subscribePeriodLabel | translate }}
                </div>
            }
            @if (element.prices[0].value) {
                <div class="card-price-block small strip-text">
                    {{ price | number: "1.2-2" }} {{ element.prices[0].currency }}
                </div>
            }
        </div>
    </div>
</div>
